import { authHeaders, getAuthToken } from "../../store/authStore";
import { getApiBaseUrl } from "../../store/workspaceStore";

/**
 * The raw profile body. Decoding lives in `../decode.ts` because the response
 * carries two shapes during the cutover and the choice between them is a
 * decision, not a transport concern.
 */
export async function fetchProfileJson(): Promise<unknown> {
  if (getAuthToken() === null) return null;
  const response = await fetch(`${getApiBaseUrl()}/api/me/profile`, {
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error("profile request failed");
  return response.json();
}

export async function retrySeeding(): Promise<void> {
  const response = await fetch(
    `${getApiBaseUrl()}/api/me/dataset-provisioning/retry`,
    { method: "POST", headers: authHeaders() },
  );
  // 409 means the seed is not `failed` any more — somebody else's tab already
  // restarted it, or it recovered on its own. That is the outcome this request
  // wanted, so treating it as a failure would leave the loser of the race
  // offering a button that can only ever 409 again.
  if (response.status === 409) return;
  if (!response.ok) throw new Error("retry failed");
}
